"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "identifier", {
  enumerable: true,
  get: function get() {
    return _identifiers.TEXT;
  }
});
Object.defineProperty(exports, "displayName", {
  enumerable: true,
  get: function get() {
    return _identifiers.TEXT;
  }
});
Object.defineProperty(exports, "options", {
  enumerable: true,
  get: function get() {
    return _factory.options;
  }
});
exports["default"] = exports.Raw = void 0;

var _reactCssThemr = require("react-css-themr");

var _Text = _interopRequireDefault(require("lemon-ui/lib/elements/Text/Text"));

var _normal = _interopRequireDefault(require("./_normal.scss"));

var _identifiers = require("../identifiers");

var _factory = _interopRequireWildcard(require("./factory"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var factoryParams = {
  identifier: _identifiers.TEXT,
  UIText: _Text["default"]
};
var Text = (0, _factory["default"])(factoryParams);
/** @component */

exports.Raw = Text;
var themed = (0, _reactCssThemr.themr)(_identifiers.TEXT, _normal["default"])(Text);
var _default = themed;
exports["default"] = _default;